module.exports = __webpack_public_path__ + "img/DNADamage-GBM_GSE194329.96c142ed.png";